import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';

import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-w2w-sw-com-performance-header-input',
  imports: [MatIcon, ReactiveFormsModule, FormsModule],
  templateUrl: './w2w-sw-com-performance-header-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './w2w-sw-com-performance-header-input.component.css'
})
export class W2wSwComPerformanceHeaderInputComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  fluidTypeSelection!: GuruEntity;
  antifreezeConcentrationSelection!: GuruEntity;
  sourceFluidFlowSelection!: GuruEntity;
  loadFluidFlowSelection!: GuruEntity;
  loadTypeSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.PERFORMANCE_INPUTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.fluidTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCFluid');
    this.antifreezeConcentrationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCFluidMix');
    this.sourceFluidFlowSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCWFR');
    this.loadFluidFlowSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USLFR');
    this.loadTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USLoadType');
  }

  textSelectionChanged(entity: GuruEntity): void {
    this.selectionChanged(entity, entity.Value);
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
